import { render, staticRenderFns } from "./RequestPage.vue?vue&type=template&id=3ff5663a&scoped=true&"
import script from "./RequestPage.vue?vue&type=script&lang=ts&"
export * from "./RequestPage.vue?vue&type=script&lang=ts&"
import style0 from "./RequestPage.vue?vue&type=style&index=0&id=3ff5663a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5663a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
